import { appRouterPaths } from "@/services/navigation/urls";

export const SPECIAL_TABS = [
  appRouterPaths.contacts.connections,
  appRouterPaths.contacts.ideas,
  appRouterPaths.contacts.commitments,
  appRouterPaths.contacts.notes,
];
